/**
 * The Manage page is "all spa keys", so it always scopes the admin list to spa-type rows.
 * Both the page fetch and the generate/revoke refetch must use the SAME params or the table
 * would reload with a different filter after a mutation.
 */
export const withDefaultType = (searchParams: URLSearchParams): string => {
  const params = new URLSearchParams(searchParams);
  if (!params.get("type")) {
    params.set("type", "spa");
  }
  return params.toString();
};
